import { Caption } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC } from 'react';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

export const ErrorMessage: FC<{ message: string; testId?: string }> = ({
  message,
  testId,
}) => (
  <div className={cx(styles.container)} data-testid={testId}>
    <Caption type='helper'>{message}</Caption>
  </div>
);
